import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import simplebar from "simplebar-vue";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "../../src/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "../router/views/BaseMixer";
import SessionTimer from "@/components/clockWork/sessionTimer.vue";
import { APP_VERSION } from "../services/config";
// var d = new Date();
// d.setDate(d.getDate() - 5);
Component.registerHooks(["metaInfo"]);
let Footer = /** @class */ (() => {
    let Footer = class Footer extends Mixins(BaseMixer) {
        get version() {
            return APP_VERSION;
        }
        get isIdle() {
            return this.$store.state.idleVue.isIdle;
        }
    };
    Footer = __decorate([
        Component({
            name: "Footer",
            components: {
                Loader,
                Layout,
                PageHeader,
                simplebar,
                SessionTimer,
            },
        })
    ], Footer);
    return Footer;
})();
export default Footer;
